'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'goal-net';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e3ab';
var svgPathData = 'M32 32L0 32 0 64 0 448l0 32 64 0 0-32L64 96l512 0 0 352 0 32 64 0 0-32 0-384 0-32-32 0L32 32zm160 96l-32 0 0 64-64 0 0 32 64 0 0 64-64 0 0 32 64 0 0 64-64 0 0 32 64 0 0 64 32 0 0-64 64 0 0 64 32 0 0-64 64 0 0 64 32 0 0-64 64 0 0 64 32 0 0-64 64 0 0-32-64 0 0-64 64 0 0-32-64 0 0-64 64 0 0-32-64 0 0-64-32 0 0 64-64 0 0-64-32 0 0 64-64 0 0-64-32 0 0 64-64 0 0-64zm64 256l-64 0 0-64 64 0 0 64zm96 0l-64 0 0-64 64 0 0 64zm96 0l-64 0 0-64 64 0 0 64zm0-96l-64 0 0-64 64 0 0 64zm-96 0l-64 0 0-64 64 0 0 64zm-96 0l-64 0 0-64 64 0 0 64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faGoalNet = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;